<template>
  <MigrationNotificationBanner
    :show="showNotification"
    :notification="currentNotification"
    @action="handleAction"
  />
</template>

<script>
import MigrationNotificationBanner from './MigrationNotificationBanner.vue';
import { getNotificationToShow, saveUserNotificationLog } from '../utils/migrationUtils';

export default {
  name: 'MigrationNotificationProvider',
  components: {
    MigrationNotificationBanner,
  },
  props: {
    initialRegion: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showNotification: false,
      currentNotification: null,
    };
  },
  mounted() {
    this.fetchNotification();
  },
  methods: {
    async fetchNotification() {
      const notification = await getNotificationToShow(this.initialRegion);

      if (notification) {
        this.currentNotification = notification;
        this.showNotification = true;
      }
    },
    handleAction(type, action) {
      if (this.currentNotification) {
        saveUserNotificationLog({
          region: this.initialRegion,
          notificationType: type,
          lastAction: action,
          timestamp: new Date().toISOString(),
        });
        this.showNotification = false;
      }
    },
  },
};
</script>
 